/**
 * Scopes `request` to the filter ID. If the client is a fallback, it will
 * listen for responses and scope the child transport `request` function
 * to the successful filter ID.
 */
export function createFilterRequestScope(client, _ref) {
  var _client$transport$onR, _client$transport;
  let {
    method
  } = _ref;
  const requestMap = {};
  if (client.transport.type === 'fallback') (_client$transport$onR = (_client$transport = client.transport).onResponse) === null || _client$transport$onR === void 0 || _client$transport$onR.call(_client$transport, _ref2 => {
    let {
      method: method_,
      response: id,
      status,
      transport
    } = _ref2;
    if (status === 'success' && method === method_) requestMap[id] = transport.request;
  });
  return id => requestMap[id] || client.request;
}
//# sourceMappingURL=createFilterRequestScope.js.map